export default "__VITE_ASSET__0eefba53__"